import clsx from 'clsx'
import Img from 'components/common/Img'
import IntLink from 'components/common/IntLink'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import useSlug from 'hooks/useSlug'
import {
  addPropIf,
  isNonEmptyArray,
  isPresent,
  isSame,
  isString,
} from 'lib/utils'
import { useMemo, useRef } from 'react'
import { ICategory, IMenuItem } from 'store/api'

type Props = {
  categoryList: ICategory[]
  leftMenu: IMenuItem[]
}

let HomeCategoryMobileMenu = ({ categoryList, leftMenu }: Props) => {
  const { slug: pageSlug } = useSlug()

  const categories = useMemo(
    () =>
      categoryList.map((c) => {
        const icon =
          leftMenu.find((i) => i.slug === c.slug)?.image ?? ''
        return {
          ...c,
          icon,
        }
      }),
    [categoryList, leftMenu]
  )

  let ref = useRef<HTMLLIElement | null>(null)

  useIsomorphicLayoutEffect(() => {
    if (
      !isString(pageSlug) &&
      isNonEmptyArray(pageSlug) &&
      isNonEmptyArray(leftMenu)
    ) {
      ref.current?.scrollIntoView({ inline: 'center' })
      window.scrollTo({ top: 0 })
    }
  }, [pageSlug])

  let initRender = useRef(true)
  useIsomorphicLayoutEffect(() => {
    if (
      initRender.current &&
      !isString(pageSlug) &&
      isNonEmptyArray(pageSlug) &&
      isNonEmptyArray(leftMenu)
    ) {
      initRender.current = false
      ref.current?.scrollIntoView({ inline: 'center' })
      window.scrollTo({ top: 0 })
    }
  }, [leftMenu])

  return (
    <div className='sticky top-[84px] z-30 lg:hidden w-full bg-white'>
      <ul className='flex overflow-x-auto omit-scrollbar colored-scrollbar px-2 md:px-8 pb-2 gap-2 bg-white'>
        {categories.map(({ id, name, slug, image }) => (
          <li
            key={id}
            {...addPropIf(
              isPresent(pageSlug) && isSame(pageSlug![0], slug),
              'ref',
              ref
            )}
          >
            <IntLink href={`/categories/${slug}`} className='w-[80px] grid border-2 border-transparent tap-no-highlight rounded-lg active:border-primary'>
              <div className='w-[64px] h-[64px] relative justify-self-center'>

                {image && (
                  <Img
                    src={image}
                    alt=''
                    layout='fill'
                    objectFit='cover'
                  />
                )}
              </div>

              <div
                className={clsx(
                  'rounded-lg p-2 text-center break-normal font-semibold text-xxs leading-tighter tracking-tight w-[80px] text-dark-600',
                  {
                    'bg-primary':
                      (isPresent(pageSlug) &&
                        pageSlug[0]! === slug),

                  }
                )}
              >
                {name}
              </div>
            </IntLink>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default HomeCategoryMobileMenu
